import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Switch,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { makeStyles } from "../../../utils/makeStyles";

interface Campaign {
  messageCampaignId: any;
  messageCampaignName: string;
  lifetimeBudget: number;
  campaignStatus: boolean;
}
interface Props {
  campaigns: Campaign[];
  adAccountName: string;
  adAccountCurrency: string;
  onOpenMessages: (campaign: Campaign) => void;
  onOpenCampaignData: (campaign: Campaign) => void;
}
const useStyles = makeStyles()({
  buttonStyles: {
    backgroundColor: "#1DA1F2",
    textTransform: "none",
    padding: "0px 6px",
    marginRight: "24px",
  },
});
const CampaignsList: React.FC<Props> = ({
  campaigns,
  adAccountName,
  adAccountCurrency,
  onOpenMessages,
  onOpenCampaignData,
}) => {
  const { classes } = useStyles();

  if (campaigns.length === 0) {
    return (
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textAlign: "center", mt: 5 }}>
        No message campaigns are available.
      </Typography>
    );
  }

  return (
    <>
      {campaigns.map((campaign) => (
        <Card
          key={campaign.messageCampaignId}
          variant="outlined"
          sx={{
            borderRadius: 3,
            mb: 2,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
            "&:hover": {
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
            },
          }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: "8px 0",
              }}>
              <Box sx={{ flex: 1, textAlign: "start" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {campaign.messageCampaignName}
                  </Typography>
                  <Box>
                    <Button
                      className={classes.buttonStyles}
                      variant="contained"
                      onClick={() => onOpenMessages(campaign)}>
                      Messages
                    </Button>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                <Switch
                  checked={Boolean(campaign.campaignStatus)}
                  size="medium"
                />
              </Box>
            </Box>

            {/* Accordion */}
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="panel2-header">
                <Typography component="span">View Campaign Details</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ pt: 0, textAlign: "start" }}>
                <Typography variant="body2" color="text.secondary">
                  <strong>AdAccount Name:</strong> {adAccountName}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>Lifetime Budget:</strong>{" "}
                  {adAccountCurrency === "USD" ? "$" : "INR"}
                  {campaign.lifetimeBudget / 100}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default CampaignsList;
